<!-- <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
    <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
</div> -->
<div class="h5">Reviews</div>
<div class="review-list" [ngClass]="gridCell?.className">
    <div class="review">
        <div class="card-header review">
            <div class="review-rating">
                <ul class="rating">
                    <li class="fas fa-star"></li>
                    <li class="fas fa-star"></li>
                    <li class="fas fa-star"></li>
                    <li class="far fa-star"></li>
                    <li class="far fa-star"></li>
                </ul>
            </div>
            <div class="review-date">2 May 1970</div>
        </div>
        <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
        <div class="card-footer">Eve Adams</div>
    </div>
    <div class="review">
        <div class="card-header review">
            <div class="review-rating">
                <ul class="rating">
                    <li class="fas fa-star"></li>
                    <li class="fas fa-star"></li>
                    <li class="fas fa-star"></li>
                    <li class="far fa-star"></li>
                    <li class="far fa-star"></li>
                </ul>
            </div>
            <div class="review-date">2 May 1970</div>
        </div>
        <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
        <div class="card-footer">Eve Adams</div>
    </div>
    <div class="review">
        <div class="card-header review">
            <div class="review-rating">
                <ul class="rating">
                    <li class="fas fa-star"></li>
                    <li class="fas fa-star"></li>
                    <li class="fas fa-star"></li>
                    <li class="far fa-star"></li>
                    <li class="far fa-star"></li>
                </ul>
            </div>
            <div class="review-date">2 May 1970</div>
        </div>
        <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
        <div class="card-footer">Eve Adams</div>
    </div>
    <div class="review">
        <div class="card-header review">
            <div class="review-rating">
                <ul class="rating">
                    <li class="fas fa-star"></li>
                    <li class="fas fa-star"></li>
                    <li class="fas fa-star"></li>
                    <li class="far fa-star"></li>
                    <li class="far fa-star"></li>
                </ul>
            </div>
            <div class="review-date">2 May 1970</div>
        </div>
        <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
        <div class="card-footer">Eve Adams</div>
    </div>
</div>

